/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDistanceType.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/distance-type";

export class AutogenModelDistanceType<RowType extends ModelRow> extends Endpoint<RowType, RowDistanceTypeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDistanceType extends ModelRow<RowDistanceTypeFields> {
	constructor(values?: Partial<RowDistanceTypeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDistanceTypeFields {
	company_id: string;
	descr: string;
	id: string;
	source_id: string;
	type_id: string;
}

